import { type ApiResponse } from '@type/api'
import { axiosProxy } from '@utils/axios'
import { type AuthDto } from '@view/auth/types'
import axios from 'axios'
import { config } from 'config'
import { jwtDecode } from 'jwt-decode'

import { writeBrowserAuthMethodMarker } from '@/shared/analytics/auth-method-marker'

// Promise<AuthDto.LoginResponse>
export async function login(data: AuthDto.LoginRequest): Promise<any> {
  return await axios.post<ApiResponse<AuthDto.LoginResponse>>('/api/login', data)
}

// :TODO Доделать
export async function registerUser(email: string, password: string, consents: AuthDto.Consents): Promise<any> {
  const response = await axios.post<any>('/api/register', {
    email,
    password,
    ...consents,
  })
  try {
    writeBrowserAuthMethodMarker('password')
  } catch {
    return response
  }
  return response
}

export async function logout(): Promise<any> {
  return await axios.post<ApiResponse<AuthDto.LoginResponse>>('/api/logout')
}

export async function checkToken(token: string): Promise<boolean> {
  try {
    const response = await axiosProxy.get('/auth/check-state-token/' + token)
    return response.data?.data?.valid === true
  } catch {
    return false
  }
}

export async function checkInviteToken(token: string): Promise<boolean> {
  try {
    const response = await axiosProxy.get('/auth/invite/check/' + token)
    return response.data?.data?.valid === true
  } catch {
    return false
  }
}

export async function checkTokenType(token: string): Promise<string> {
  try {
    const response = await axiosProxy.get('/auth/check-token-type/' + token)
    return response.data?.data?.token_type
  } catch {
    return 'unknown'
  }
}

export async function getVkAuthUrl(state: string = '') {
  return axiosProxy.get('/oauth/vk/url?state=' + state + (config.isDev ? '&is_dev=' + config.isDev : ''))
}

// Mail.ru не позволяется авторизоваться без state
// Требуется передавать хоть что-то, хоть цифру 0
export async function getMailruAuthUrl(state: string = 'empty') {
  if (!state) {
    state = 'empty'
  }
  return axiosProxy.get('/oauth/mailru/url?state=' + state + (config.isDev ? '&is_dev=' + config.isDev : ''))
}

export async function getTelegramAuthUrl() {
  return axiosProxy.get('/auth/telegram/url')
}

export interface JwtMessage {
  message?: string
}

export function parseJwt(token: string | null) {
  try {
    if (!token) {
      return null
    }
    return jwtDecode(token) as JwtMessage
  } catch {
    return null
  }
}
